import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DatabaseTableComponent } from './database-table.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CustomDropdownModule } from 'src/app/shared/components/custom-dropdown/custom-dropdown.module';
import { CustomDatePickerModule } from 'src/app/shared/components/custom-date-picker/custom-date-picker.module';
import { MatPaginatorModule } from '@angular/material/paginator';
import { CustomTimpickerModule } from 'src/app/shared/components/custom-timpicker/custom-timpicker.module';
import { MaterialModule } from 'src/app/shared/material/material.module';
import { CustomInputModule } from "../../shared/components/custom-input/custom-input.module";



@NgModule({
    declarations: [
        DatabaseTableComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        CustomDropdownModule,
        CustomDatePickerModule,
        ReactiveFormsModule,
        MaterialModule,
        MatPaginatorModule,
        CustomTimpickerModule,
        CustomInputModule
    ]
})
export class DatabaseTableModule { }
